import axios from 'axios'
import AuthService from './../../services/auth.service'
import LocalStorageService from '../../services/refresh.service'
import Role from '@/models/enums/Roles'
import CRMPermission from '@/models/enums/permissions/CRMPermission'

const localStorageService = LocalStorageService.getService()
let user = null

if (localStorage.getItem('user')) {
  const data = JSON.parse(localStorage.getItem('user'))
  user = data.data
}

const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null }

const state = {
  initialState,
  user,
  filials: null,
  userFilials: localStorage.getItem('userFilials') ? JSON.parse(localStorage.getItem('userFilials')) : [],
  refreshPromise: null,
}

const actions = {
  login ({ commit }, user) {
    return AuthService.login(user).then(
      (user) => {
        commit('loginSuccess', user)
        return Promise.resolve(user)
      },
      (error) => {
        commit('loginFailure')
        return Promise.reject(error)
      },
    )
  },
  loginAs ({ commit }, userId) {
    return AuthService.loginAs(userId).then((user) => {
      commit('loginSuccess', user)
      return user
    })
  },
  logout ({ commit }) {
    AuthService.logout()
    commit('logout')
  },
  whoami ({ commit }) {
    AuthService.whoami().then(() => {
      commit('updateFilials')
    })
  },
  fetchUser ({ commit }) {
    return AuthService.whoami()
      .then(res => {
        commit('setUser', res.data)
        return res.data
      })
  },
  refresh ({ commit, getters, rootGetters, dispatch }) {
    if (getters.getRefreshPromise) {
      return getters.getRefreshPromise
    }

    const refreshPromise = axios
      .post(rootGetters['api/authRefresh'])
      .then((res) => {
        axios.defaults.headers.common.Authorization = `Bearer ${res.data.token}`
        localStorageService.setToken(res.data.token)
        commit('setRefreshPromise', null)
        return res
      })
    commit('setRefreshPromise', refreshPromise)

    return refreshPromise
  },
}

const mutations = {
  updateFilials (state) {
    state.userFilials = localStorage.getItem('userFilials') ? JSON.parse(localStorage.getItem('userFilials')) : []
  },
  loginSuccess (state, user) {
    state.initialState.status.loggedIn = true
    state.initialState.user = user
    state.user = user.data
    state.filials = user.filials
    state.userFilials = localStorage.getItem('userFilials') ? JSON.parse(localStorage.getItem('userFilials')) : []
  },
  loginFailure (state) {
    state.initialState.status.loggedIn = false
    state.initialState.user = null
  },
  logout (state) {
    state.initialState.status.loggedIn = false
    state.user = null
    state.initialState.user = null
  },
  setRefreshPromise (state, promice) {
    state.refreshPromise = promice
  },
  setUser (state, data) {
    state.user = data
    state.initialState.user = data
    console.log('===data.allPermissions==', data.allPermissions)
  },
}

const getters = {
  loggedIn (state) {
    return state.initialState.status.loggedIn
  },
  getUser (state) {
    return state.user
    /* if (localStorage.getItem('user')) {
      return JSON.parse(localStorage.getItem('user') || '{}')
    } */
    // return null
  },
  getRefreshPromise (state) {
    return state.refreshPromise
  },
  getRoles (state) {
    return state?.user?.allPermissions?.roles || {}
  },
  getPermissions (state) {
    return state?.user?.allPermissions?.permissions || {}
  },
  isCallCenterUser (state) {
    return !!state?.user?.isCallCenterUser
  },
  // флаги сотрудника для правил отмены и возврата (util/order-cancel). Суперадмина бэк не ограничивает (Gate::before)
  orderCancelFlags (state, getters) {
    const roles = getters.getRoles
    const permissions = getters.getPermissions
    const isSuperAdmin = Array.isArray(roles) && roles.includes(Role.SuperAdmin)

    return {
      isCallCenter: getters.isCallCenterUser,
      cancelForbidden: !isSuperAdmin && state?.user?.canCancelOrders === false,
      canCancelPastShift: isSuperAdmin || state?.user?.canCancelPastShiftOrders === true ||
        (Array.isArray(permissions) && permissions.includes(CRMPermission.CancelPastShiftOrders)),
    }
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
